import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import DashboardLayout from './components/DashboardLayout';
import DashboardHome from './pages/dashboard/DashboardHome';
import AddProduct from './pages/dashboard/AddProduct';
import MyProducts from './pages/dashboard/MyProducts';
import StoreView from './pages/StoreView'; // Jo pehle banaya tha
import Settings from './pages/dashboard/Settings'; // Naya page for settings
import Login from './pages/Login';
import OrdersPage from './pages/dashboard/OrdersPage';
import CategoryManager from './pages/dashboard/CategoryManager'; // Naya page for category management
import { Toaster } from 'react-hot-toast';

function App() {
  return (
    
    <Router>
      <Routes>
        {/* Public Route */}
        <Route path="/shop/:shopName" element={<StoreView />} />

        {/* Dashboard Routes - Sab DashboardLayout ke andar wrapped hain */}
        <Route path="/dashboard" element={<DashboardLayout><DashboardHome /></DashboardLayout>} />
        <Route path="/dashboard/add-product" element={<DashboardLayout><AddProduct /></DashboardLayout>} />
        <Route path="/dashboard/edit-product/:id" element={<DashboardLayout><AddProduct /></DashboardLayout>} />
        <Route path="/dashboard/my-products" element={<DashboardLayout><MyProducts /></DashboardLayout>} />
        <Route path="/dashboard/settings" element={<DashboardLayout><Settings /></DashboardLayout>} />
        <Route path="/dashboard/orders" element={<DashboardLayout><OrdersPage /></DashboardLayout>} />
        <Route path="/dashboard/categories" element={<DashboardLayout><CategoryManager /></DashboardLayout>} />
        
        {/* Default Route */}
        <Route path="/" element={<Login />} />
      </Routes>
      <Toaster position="top-right" toastOptions={{ duration: 3000 }} />
    </Router>
  );
}

export default App;